import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import RemCalc from '../../utils/rem-calc';
import Container from '../Container';
import CtaButtonSearch from '../CtaButtonSearch';

export const Section = styled.section`
  position: relative;
  width: 100%;
  max-width: 100%;
  padding: 3.75rem 0;
  margin: 0 auto;
  overflow: hidden;
  z-index: 1;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    padding: 2.5rem 0;
    margin: 0 auto;
  }
`;

export const SectionContainer = styled(Container)`
  position: relative;
  padding: 0 2rem;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    padding: 0 1rem;
  }

  form {
    margin-bottom: 0px;
    padding: 0 1rem;
    position: relative;
  }
`;

export const LocationPageTitle = styled.div`
  position: relative;
  text-align: center;

  h1 {
    margin-bottom: 1em;
    line-height: 1.2;

    span {
      color: ${themeGet('colors.phoenix-red')};
    }
  }
`;

export const Search = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  width: 100%;
  max-width: 626px;
  margin: 0 auto;
`;

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  @media (max-width: ${themeGet('breakpoints.xs')}) {
    justify-content: center;
    flex-direction: column;
  }

  input {
    padding: 0 9.65rem 0 60px;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      padding: 0 8.65rem 0 60px;
    }

    @media (max-width: ${themeGet('breakpoints.xs')}) {
      padding-right: 50px;
    }

    &:lang(fr) {
      padding: 0 11.65rem 0 60px;

      @media (max-width: ${themeGet('breakpoints.md')}) {
        padding: 0 10.65rem 0 60px;
      }
      @media (max-width: ${themeGet('breakpoints.xs')}) {
        padding-right: 50px;
      }
    }
  }

  > * {
    margin-bottom: 0;
  }
`;

export const ClearButton = styled.button`
  margin: 0;
  height: 2.25rem;
  min-height: 2.25rem;
  font-size: 0.875rem;
  padding: 0.438rem 0.5rem;
  position: absolute;
  right: 126px;
  top: 0.875rem;
  cursor: pointer;
  background: transparent;
  border: 0;
  border-right: 1px solid
    ${({ themes }) =>
      themes === 'dark'
        ? themeGet('colors.grey')
        : themeGet('colors.divider-grey-light')};
  transform: scale(1.4, 1);

  color: ${({ themes }) =>
    themes === 'dark'
      ? themeGet('colors.grey')
      : themeGet('colors.divider-grey-light')};

  @media (max-width: ${themeGet('breakpoints.md')}) {
    top: 7px;
    height: 1.8rem;
    min-height: 1.8rem;
    right: 114px;
  }

  @media (max-width: ${themeGet('breakpoints.xs')}) {
    border-right: none;
    right: 20px;
  }

  &:lang(fr) {
    right: 156px;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      top: 7px;
      height: 1.8rem;
      min-height: 1.8rem;
      right: 144px;
    }

    @media (max-width: ${themeGet('breakpoints.xs')}) {
      border-right: none;
      right: 20px;
    }
  }
`;

export const SubmitButton = styled(CtaButtonSearch)`
  margin: 0;
  height: 2.25rem;
  min-height: 2.25rem;
  font-size: 0.875rem;
  padding: 0.438rem 1.25rem;
  position: absolute;
  right: 20px;
  top: 0.875rem;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    top: 7px;
    right: 7px;
    height: 1.8rem;
    min-height: 1.8rem;
    padding: 0 1.25rem;
  }

  @media (max-width: ${themeGet('breakpoints.xs')}) {
    position: relative;
    margin: 1rem auto 0;
    right: 0;
    left: 0;
    top: 0;
  }
`;

export const SearchResults = styled.section`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background-color: transparent;
  border-top: 1px solid ${themeGet('colors.white-pale')};
  border-bottom: 1px solid ${themeGet('colors.white-pale')};

  @media (max-width: ${themeGet('breakpoints.md')}) {
    border-bottom: none;
  }
`;

export const Summary = styled.div`
  width: 100%;
  padding: 1rem;
  text-align: center;
  background-color: ${themeGet('colors.body-bg')};
  border-right: 1px solid ${themeGet('colors.white-pale')};

  @media (max-width: ${themeGet('breakpoints.md')}) {
    border-right: none;
    border-bottom: 1px solid ${themeGet('colors.white-pale')};
  }

  &.view-desktop {
    display: block;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      display: none;
    }
  }

  &.view-mobile {
    display: none;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      display: block;
    }
  }

  &.error {
    p {
      color: ${({ themes }) =>
        themes === 'dark'
          ? themeGet('colors.white-hover')
          : themeGet('colors.phoenix-red')};
    }
  }

  p {
    margin: 0;
    line-height: 1.4;
    font-size: 0.9rem;
  }
`;

export const TabContainer = styled(Container)`
  display: none;
  position: relative;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto;
  padding: 2rem 0;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    display: flex;
  }
`;

export const TabButton = styled.button`
  display: flex;
  position: relative;
  color: ${themeGet('colors.white')};
  font-size: 1.25rem;
  font-weight: ${themeGet('fontWeights.medium')};
  padding: 0.375rem 0.688rem;
  text-underline-position: under;
  cursor: pointer;
  width: 10rem;
  height: 2.438rem;
  border: 0;
  justify-content: center;
  align-items: center;

  ${({ themes }) =>
    themes === 'dark'
      ? css`
          background-color: ${themeGet('colors.grey')};
        `
      : css`
          background-color: ${themeGet('colors.black')};
        `};

  @media (max-width: ${themeGet('breakpoints.xs')}) {
    width: calc(50% - 2rem);
  }

  @media (max-width: ${themeGet('breakpoints.xxs')}) {
    font-size: 0.8rem;
  }

  &.active {
    background-color: ${themeGet('colors.phoenix-red')};
  }

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    text-decoration: underline;
    outline-color: ${themeGet('colors.body-copy')};
  }

  &:first-child {
    border-radius: 25px 0 0 25px;
    border-right: none;

    &:after {
      content: '';
      position: absolute;
      display: block;
      right: 0;
      top: 0;
      margin: 0 auto;
      height: 100%;
      width: 1px;
      background-color: ${themeGet('colors.white-pale')};
      z-index: 2;
    }
  }

  &:last-child {
    border-radius: 0 25px 25px 0;
    border-left: none;
  }
`;

export const ResultsRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: wrap;
  position: relative;
  background-color: ${themeGet('colors.body-bg')};

  @media (max-width: ${themeGet('breakpoints.md')}) {
    padding: 0 2rem;
    height: 50vh;
  }
`;

export const StoreListing = styled.div`
  width: ${RemCalc(400)};
  min-width: 25%;
  height: 40rem;
  overflow-y: scroll;
  order: 1;
  border-right: 1px solid ${themeGet('colors.white-pale')};
  background: ${({ themes }) =>
    themes === 'dark'
      ? 'linear-gradient(to top, #4a4a4f, transparent 20%)'
      : 'linear-gradient(to top, #e9eaeb, transparent 20%)'};

  @media (max-width: ${themeGet('breakpoints.lg')}) {
    width: ${RemCalc(300)};
  }

  @media (max-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - 4rem);
    height: 50vh;
    order: 2;
    border-left: 1px solid ${themeGet('colors.white-pale')};
    border-bottom: 1px solid ${themeGet('colors.white-pale')};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 1;
    opacity: 0;
    visibility: hidden;
  }

  &.active {
    @media (max-width: ${themeGet('breakpoints.md')}) {
      z-index: 3;
      opacity: 1;
      visibility: visible;
    }
  }

  // Scrollbar
  /* width */
  &::-webkit-scrollbar {
    margin: 0;
    padding: 1rem 0;
    width: 1rem;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: ${themeGet('colors.white')};

    ${({ themes }) =>
      themes === 'dark'
        ? css`
            background: ${themeGet('colors.grey')};
          `
        : css`
            background: ${themeGet('colors.white')};
          `};
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${themeGet('colors.black')};
    border-radius: 1rem;
    height: 12rem;
    box-shadow: none;

    ${({ themes }) =>
      themes === 'dark'
        ? css`
            background: ${themeGet('colors.grey-medium')};
            border: 3px solid ${themeGet('colors.grey')};
          `
        : css`
            background: ${themeGet('colors.black')};
            border-left: 4px solid ${themeGet('colors.white')};
            border-top: 4px solid ${themeGet('colors.white')};
            border-bottom: 4px solid ${themeGet('colors.white')};
            border-right: 3px solid ${themeGet('colors.white')};
          `};
  }
`;

export const GoogleMap = styled.div`
  height: 40rem;
  flex: 1 1 auto;
  background-color: #eee;
  order: 2;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
    height: 50vh;
    min-height: 20rem;
    max-height: 40rem;
    order: 1;
    border: 1px solid ${themeGet('colors.white-pale')};
    position: relative;
    z-index: 2;
    opacity: 0;
  }

  &.active {
    @media (max-width: ${themeGet('breakpoints.md')}) {
      z-index: 3;
      opacity: 1;
    }
  }

  // Google infoWindow styles
  .gm-style {
    width: 200px;
    font-family: ${themeGet('fonts.poppins')};

    @media (max-width: ${themeGet('breakpoints.sm')}) {
      width: 100%;
    }

    .poi-info-window div {
      background: ${themeGet('colors.body-bg')};
      color: ${themeGet('colors.body-copy')};

      .address {
        margin-bottom: 1rem;
      }

      a {
        &:link {
          background: ${themeGet('colors.body-bg')};
          text-decoration: underline;
          color: ${themeGet('colors.body-copy')};

          &:hover {
            color: ${({ themes }) =>
              themes === 'dark'
                ? themeGet('colors.white-hover')
                : themeGet('colors.phoenix-red')};
          }
        }
      }
    }

    .gm-style-iw-t {
      background: ${themeGet('colors.body-bg')};

      &:after {
        background: ${themeGet('colors.body-bg')};
      }
    }
    .gm-style-iw {
      padding: 15px 40px 20px 20px !important;
      background: ${themeGet('colors.body-bg')};
      color: ${themeGet('colors.body-copy')};
      max-width: 100% !important;

      button {
        top: 8px !important;
        right: 5px !important;
        color: ${themeGet('colors.body-copy')};

        img {
          ${({ themes }) =>
            themes === 'dark' &&
            css`
              filter: brightness(0) invert(1);
            `}
        }
      }

      .gm-style-iw-d {
        overflow: hidden !important;
        background: ${themeGet('colors.body-bg')};

        &:after {
          background: ${themeGet('colors.body-bg')};
        }
      }

      .marker-wrapper {
        .marker-logo-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding-bottom: 1rem;

          .marker-logo {
            padding: 0.2rem;
            width: 6rem;

            img {
              width: 100%;
            }
          }

          .marker-store-distance {
            color: ${themeGet('colors.body-copy')};
            font-weight: ${themeGet('fontWeights.bold')};
            justify-self: flex-end;
            font-size: 0.8rem;
            line-height: 0.8rem;
          }
        }
        .marker-group {
          width: 100%;

          .marker-store-name {
            color: ${themeGet('colors.body-copy')};
            font-weight: ${themeGet('fontWeights.bold')};
            font-size: 0.8rem;
            line-height: 1.4;
            padding-bottom: 1rem;
            width: 170px;
          }

          .marker-directions {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            position: relative;

            a {
              &.marker-directions-anchor {
                width: 170px;
                text-decoration: underline;
                text-underline-position: under;
                color: ${themeGet('colors.body-copy')};

                &:hover {
                  color: ${({ themes }) =>
                    themes === 'dark'
                      ? themeGet('colors.white-hover')
                      : themeGet('colors.phoenix-red')};

                  .marker-directions-icon {
                    opacity: 0.7;
                    transition: opacity 150ms ease-out;
                  }
                }
              }
            }

            .marker-directions-address {
              font-size: 0.7rem;
              line-height: 1.4;
              padding-right: 25px;
            }

            .marker-directions-icon {
              justify-self: flex-end;
              width: 30px;
              height: 30px;
              position: absolute;
              bottom: -5px;
              right: -5px;
              opacity: 1;
              transition: opacity 150ms ease-out;
            }
          }
        }
      }
    }
  }
`;
